<template>
  <div
    class="modal fade"
    id="echarts_e_flow_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title" id="myModalLabel">折线图</h4>
        </div>
        <!-- modal-body-->
        <div class="modal-body">
          <div id="echarts_dom" style="width:980px;height:650px"></div>
        </div>
        <!-- modal-footer -->
        <!-- <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">提交</button>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
var myChart, option;
export default {
  data() {
    return {};
  },
  props: ["msgStation"],
  mounted: function () {
    let self = this;
  },
  methods: {
    echartsInt: function () {
      let self = this;
      // echarts 初始化
      myChart = self.echarts.init(document.getElementById("echarts_dom"));
      option = {
        backgroundColor: "#1A1835",

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff",
            },
          },
        },
        grid: {
          borderWidth: 0,
          top: 110,
          bottom: 95,
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          x: "46%",
          top: "11%",
          textStyle: {
            color: "#90979c",
          },
          data: ["支出", "收入"],
        },

        calculable: true,
        xAxis: [
          {
            type: "time",
            axisLine: {
              lineStyle: {
                color: "rgba(204,187,225,0.5)",
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            data: [],
          },
        ],

        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(204,187,225,0.5)",
              },
            },
          },
        ],
        dataZoom: [
          {
            show: true,
            height: 30,
            xAxisIndex: [0],
            bottom: 30,

            start: 0,
            end: 100,
            handleIcon:
              "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "110%",
            handleStyle: {
              color: "#5B3AAE",
            },
            textStyle: {
              color: "rgba(204,187,225,0.5)",
            },
            fillerColor: "rgba(67,55,160,0.4)",
            borderColor: "rgba(204,187,225,0.5)",
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        series: [
          {
            name: "支出",
            type: "line",
            symbolSize: 10,
            symbol: "circle",
            itemStyle: {
              color: "#6f7de3",
            },
            markPoint: {
              label: {
                normal: {
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],
            },
            data: [],
          },
          {
            name: "收入",
            type: "line",
            symbolSize: 10,
            symbol: "circle",
            itemStyle: {
              color: "#c257F6",
            },
            markPoint: {
              label: {
                normal: {
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],
            },
            data: [],
          },
        ],
      };
      //   console.log('12aaa')
      //   myChart.setOption(option);
      //   console.log)
    },
    // 累计用电量 1 最后表底数 2  分段日耗 3
    echartsDateInt: function (param, eFlowListItem) {
      let self = this;
      self.echartsInt();
      console.log(param, eFlowListItem);
      var eFlowList = eFlowListItem.historys;
      var stst_commcontractstar = eFlowListItem.stst_commcontractstar; // 局方合同开始日期(用于计算日耗)
      var xData = []; // X轴数据
      var yData1 = [],
        yData2 = []; // 收入/支出
      var used_all_in = 0,
        used_all_out = 0; // 累计用电量
      // [['2020-01-12',857],['2020-01-13',857]]
      for (var i = 0; i < eFlowList.length; i++) {
        switch (param * 1) {
          // 累计用电量
          case 1:
            xData.push(eFlowList[i].current_time.split(" ")[0]);
            if (
              eFlowList[i].type == 1 ||
              eFlowList[i].type == 4 ||
              eFlowList[i].type == 6
            ) {
              used_all_in += eFlowList[i].used * 1;
              yData1.push([
                eFlowList[i].current_time.split(" ")[0],
                used_all_in,
              ]);
            } else if (
              eFlowList[i].type == 2 ||
              eFlowList[i].type == 5 ||
              eFlowList[i].type == 7
            ) {
              used_all_out += eFlowList[i].used * 1;
              yData2.push([
                eFlowList[i].current_time.split(" ")[0],
                used_all_out,
              ]);
            }
            break;
          // 最后表底数
          case 2:
            xData.push(eFlowList[i].current_time.split(" ")[0]);
            if (
              eFlowList[i].type == 1 ||
              eFlowList[i].type == 4 ||
              eFlowList[i].type == 6
            ) {
              yData1.push([
                eFlowList[i].current_time.split(" ")[0],
                eFlowList[i].current_reading,
              ]);
            } else if (
              eFlowList[i].type == 2 ||
              eFlowList[i].type == 5 ||
              eFlowList[i].type == 7
            ) {
              yData2.push([
                eFlowList[i].current_time.split(" ")[0],
                eFlowList[i].current_reading,
              ]);
            }
            break;
          // 分段日耗
          case 3:
            xData.push(stst_commcontractstar);
            if (
              eFlowList[i].type == 1 ||
              eFlowList[i].type == 4 ||
              eFlowList[i].type == 6
            ) {
              if (i == 0) {
                //   stst_commcontractstar;
                // xData.push(eFlowList[i].current_reading);
                let timeDifference =
                  (new Date(eFlowList[i].current_reading) -
                    new Date(stst_commcontractstar)) /
                  86400000;
                yData1.push([
                  stst_commcontractstar,
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
                yData1.push([
                  eFlowList[i].current_time.split(" ")[0],
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
              } else {
                yData1.push([
                  eFlowList[i - 1].current_time.split(" ")[0],
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
                yData1.push([
                  eFlowList[i].current_time.split(" ")[0],
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
              }
            } else if (
              eFlowList[i].type == 2 ||
              eFlowList[i].type == 5 ||
              eFlowList[i].type == 7
            ) {
              if (i == 0) {
                // xData.push(eFlowList[i].current_reading);
                let timeDifference =
                  (new Date(eFlowList[i].current_reading) -
                    new Date(stst_commcontractstar)) /
                  86400000;
                yData2.push([
                  stst_commcontractstar,
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
                yData2.push([
                  eFlowList[i].current_time.split(" ")[0],
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
              } else {
                yData1.push([
                  eFlowList[i - 1].current_time.split(" ")[0],
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
                yData1.push([
                  eFlowList[i].current_time.split(" ")[0],
                  (eFlowList[i].used / timeDifference).toFixed(2),
                ]);
              }
            }

            break;

          default:
            break;
        }
      }
      console.log(xData, yData1, yData2);
      option.xAxis[0].data = xData;
      option.series[0].data = yData1;
      option.series[1].data = yData2;
      myChart.setOption(option, true);
      console.log(myChart.getOption());
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/echartsEFlow.vue